<template>
  <div
    v-bind='$attrs'
    data-cy='badge-field'
    class='!justify-start'
  >
    <label
      v-if='label'
      :for='name'
      class='block min-w-max gap-0.5 truncate text-sm font-normal'
    >
      <QuestionMarkCircleIcon
        v-if='help'
        class='question-mark-circle-icon mb-1 mr-0.5 inline-block h-4 w-4 cursor-pointer'
        @click='setHelpModalVisibility(true)'
      />
      <span
        :title='label'
        v-html='getLabel()'
      />
    </label>

    <div class='mt-1'>
      <div class='flex flex-wrap gap-2'>
        <span
          v-for='[key, val] in formattedEntries'
          :key='key'
          class='rounded-full px-3 py-1 text-xs font-semibold'
          :class='val ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"'
        >
          {{ formatKey(key) }}
        </span>

        <span
          v-if='!formattedEntries.length'
          class='text-sm text-gray-400'
        >—</span>
      </div>

      <InputError :error='error' />
    </div>
  </div>

</template>

<script lang="ts">
  import { computed, defineComponent } from 'vue'
  import useInputFieldBase, { InputFieldProps,
                              InputFieldComponents,
                              InputFieldEmits } from '../../../compositions/useInputFieldBase'
  import useInputFieldHasHelp, { InputFieldHasHelpProps,
                                 InputFieldHasHelpComponents } from '../../../compositions/useInputFieldHasHelp'

  export default defineComponent({
    name: 'BadgeField',
    components: {
      ...InputFieldComponents,
      ...InputFieldHasHelpComponents,
    },
    props: {
      ...InputFieldProps,
      ...InputFieldHasHelpProps,
    },
    emits: [
      ...InputFieldEmits,
      'has-focus',
    ],
    setup(props) {
      const { helpVisible, setHelpModalVisibility } = useInputFieldHasHelp()
      const { getLabel } = useInputFieldBase()

      const items = computed<Record<string, boolean>>(() => {
        const v = props.modelValue as unknown

        if (v == null || v === '') return {
        }

        if (typeof v === 'string') {
          try {
            const parsed = JSON.parse(v)
          
            return normalize(parsed)
          } catch {
            return {
            }
          }
        }
        
        return normalize(v)
      })

      function normalize(input: unknown): Record<string, boolean> {
        if (Array.isArray(input)) {
          return input.reduce((acc, k) => {
            acc[String(k)] = true
            
            return acc
          }, {
          } as Record<string, boolean>)
        }
        if (input && typeof input === 'object') {
          const out: Record<string, boolean> = {
          }

          Object.entries(input as Record<string, unknown>).forEach(([k, val]) => {
            out[k] = !!val
          })
          
          return out
        }
        
        return {
        }
      }

      const formattedEntries = computed<[string, boolean][]>(() => Object.entries(items.value))

      function formatKey(key: string): string {
        return key
          .split(/[._-]/g)
          .map(w => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
          .join(' ')
      }

      return {
        helpVisible,
        setHelpModalVisibility,
        getLabel,
        formattedEntries,
        formatKey,
      }
    },
  })
</script>

<style scoped>
span {
  line-height: 1.25rem;
}
</style>
